import React, { useEffect, useState } from "react";
import "./event.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import CarouselEvent from "./components/carouselEvent/CarouselEvent";
import VoidSpace from "../../components/voidSpace/VoidSpace";

import Linkify from "linkify-react";

import { getDetailsEventWS, viewEventPageWS } from "./api/eventApi";

import moment from "moment";
import { t } from "i18next";
import { gestioneSnackbar } from "../../utils/common";
import { useNavigate, useParams } from "react-router-dom";
import { isEmpty } from "../../utils/validation";
import { Col, Row } from "react-bootstrap";
import { useScreenSize } from "../../ScreenSizeContext";
import { formatDateRange } from "../../utils/formatDateRange";
import ShiftBox from "./components/shiftBox/ShiftBox";

const Event = () => {
  const isPC = useScreenSize();
  const navigate = useNavigate();
  const { id_event } = useParams();

  const [data, setData] = useState({});
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const mesi = t("calendar.abbr_months", { returnObjects: true });

  useEffect(() => {
    getDetailsEventWS({ id: id_event })
      .then((res) => {
        setData(res);
        setStartDate(moment(res.start_date, "DD/MM/YYYY HH:mm:ss"));
        setEndDate(moment(res.end_date, "DD/MM/YYYY HH:mm:ss"));
      })
      .catch((err) => {
        navigate("-1");
        gestioneSnackbar(true, err, "error");
      });

    viewEventPageWS({ id: id_event });
  }, [id_event]);

  const optionsLinkify = {
    target: "_blank",
    rel: "noopener noreferrer",
  };

  return (
    <>
      <HeaderBar title={t("common.details")} back={true} />
      {!isEmpty(data) ? (
        <>
          {!isPC ? (
            <div className="first-carousel-event">
              <CarouselEvent
                photo={data.photo.length > 0 ? data.photo : [{ image: null }]}
                height={isPC ? 300 : 250}
                borderRadius={0}
              />
            </div>
          ) : null}

          {isPC ? (
            <>
              <Row sm={1} lg={2} className="w-100">
                <Col sm={12} md={12} lg={6}>
                  <div className="event-container">
                    <div className="carousel-event-photo">
                      <CarouselEvent
                        photo={
                          data.photo.length > 0
                            ? data.photo
                            : [{ image: null, image_type: null }]
                        }
                        height={isPC ? 300 : 250}
                      />
                    </div>
                    <div className="event-wrapper">
                      <div className="information">
                        <div className="title">{data.name}</div>
                        <div
                          className="name-association"
                          onClick={() =>
                            navigate("/association/" + data.info_association.id)
                          }
                        >
                          {data.info_association.name}
                        </div>
                        <div className="description">
                          <Linkify options={optionsLinkify}>
                            {data.description}
                          </Linkify>
                        </div>
                      </div>
                      <div className="row-calendar-address">
                        <div className="column">
                          <div className="icon">
                            <span className="lnr lnr-calendar-full"></span>
                          </div>
                          <div className="title">
                            {startDate.date()} {mesi[startDate.month()]}{" "}
                            {startDate.year()}
                          </div>
                          <div className="description">
                            {formatDateRange(
                              startDate.format("YYYY-MM-DD HH:mm"),
                              endDate.format("YYYY-MM-DD HH:mm"),
                              "YYYY-MM-DD HH:mm",
                              "YYYY-MM-DD HH:mm"
                            )}
                          </div>
                        </div>
                        <div className="column left-margin">
                          <div className="icon">
                            <span className="lnr lnr-map-marker"></span>
                          </div>
                          <div className="title">{t("common.address")}</div>
                          <div className="description">{data.address}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={12} lg={6}>
                  {!isEmpty(data.shift) ? (
                    <div className="shift-information container-on-right">
                      <div className="title">{t("event.available_shift")}</div>
                      {data.shift.map((item, index) => {
                        return (
                          <ShiftBox
                            key={index}
                            id={item.id}
                            address={data.address}
                            title={item.title}
                            description={item.description}
                            startDatetime={item.start_datetime}
                            endDatetime={item.end_datetime}
                            qtaAvailable={item.available_spots}
                            isAdmin={data.is_admin}
                            eventFinished={data.terminated}
                            alreadySubscribed={!!item.i_am_subscribed} //Converte il valore in booleano
                            linkMoreDetails={`/event/${id_event}/${item.id}?admin=${data.info_association.id}`}
                          />
                        );
                      })}
                    </div>
                  ) : null}
                </Col>
              </Row>
            </>
          ) : (
            <div className="event-container container-responsive">
              <div className="event-wrapper">
                <div className="information">
                  <div className="title">{data.name}</div>
                  <div
                    className="name-association"
                    onClick={() =>
                      navigate("/association/" + data.info_association.id)
                    }
                  >
                    {data.info_association.name}
                  </div>
                  <div className="description">
                    <Linkify options={optionsLinkify}>
                      {data.description}
                    </Linkify>
                  </div>
                </div>
                <div className="row-calendar-address">
                  <div className="column">
                    <div className="icon">
                      <span className="lnr lnr-calendar-full"></span>
                    </div>
                    <div className="title">
                      {startDate.date()} {mesi[startDate.month()]}{" "}
                      {startDate.year()}
                    </div>
                    {startDate && endDate ? (
                      <div className="description">
                        {formatDateRange(
                          startDate.format("YYYY-MM-DD HH:mm"),
                          endDate.format("YYYY-MM-DD HH:mm"),
                          "YYYY-MM-DD HH:mm",
                          "YYYY-MM-DD HH:mm"
                        )}
                      </div>
                    ) : null}
                  </div>
                  <div className="column left-margin">
                    <div className="icon">
                      <span className="lnr lnr-map-marker"></span>
                    </div>
                    <div className="title">{t("common.address")}</div>
                    <div className="description">{data.address}</div>
                  </div>
                </div>
                {!isEmpty(data.shift) ? (
                  <div className="shift-information">
                    <div className="title">{t("event.available_shift")}</div>

                    {data.shift.map((item, index) => {
                      return (
                        <ShiftBox
                          key={index}
                          id={item.id}
                          address={data.address}
                          title={item.title}
                          description={item.description}
                          startDatetime={item.start_datetime}
                          endDatetime={item.end_datetime}
                          qtaAvailable={item.available_spots}
                          isAdmin={data.is_admin}
                          eventFinished={data.terminated}
                          alreadySubscribed={!!item.i_am_subscribed} //Converte il valore in booleano
                          linkMoreDetails={`/event/${id_event}/${item.id}?admin=${data.info_association.id}`}
                        />
                      );
                    })}
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </>
      ) : null}
      <VoidSpace />
    </>
  );
};

export default Event;
